import { Checkbox } from "@/components/ui/checkbox";
import { Sparkles } from "lucide-react";

// Checkbox consenso privacy (GDPR art. 13) per i form pubblici di lead.
export function PrivacyConsent({ checked, onCheckedChange, testid = "privacy-consent", className = "" }) {
  return (
    <label className={`flex cursor-pointer items-start gap-2.5 rounded-lg border border-border/60 bg-[#F0F4F1] p-3 text-xs leading-relaxed text-muted-foreground ${className}`}>
      <Checkbox checked={checked} onCheckedChange={onCheckedChange} data-testid={testid} className="mt-0.5" />
      <span>
        Dichiaro di aver letto l'
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="font-medium text-terracotta underline">Informativa Privacy</a>{" "}
        e acconsento al trattamento dei miei dati per rispondere alla presente richiesta informativa e per l'invio della documentazione.
        <span className="text-red-500"> *</span>
      </span>
    </label>
  );
}

// Link legali per i footer delle pagine pubbliche.
export function LegalFooterLinks({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] text-muted-foreground ${className}`}>
      <a href="/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-forest" data-testid="footer-privacy">Privacy Policy</a>
      <span aria-hidden>·</span>
      <a href="/cookie" target="_blank" rel="noopener noreferrer" className="underline hover:text-forest" data-testid="footer-cookie">Cookie Policy</a>
      <span aria-hidden>·</span>
      <a href="/ai" target="_blank" rel="noopener noreferrer" className="underline hover:text-forest" data-testid="footer-ai">Uso dell'Intelligenza Artificiale</a>
    </div>
  );
}

// Etichetta di trasparenza per i contenuti generati dall'IA (AI Act art. 50).
// variant "audio" = voce sintetica; "text" = documento/testo generato.
export function AiContentBadge({ variant = "audio", className = "" }) {
  const text = variant === "audio"
    ? "Contenuto generato con Intelligenza Artificiale (testo e voce sintetica) a partire dalla documentazione ufficiale di prodotto. Finalità esclusivamente informativa: non costituisce offerta al pubblico né consulenza personalizzata."
    : "Contenuto generato con l'ausilio di sistemi di Intelligenza Artificiale sulla base delle fonti ufficiali e verificato da un intermediario iscritto al RUI. Non sostituisce le Condizioni di polizza, che prevalgono in ogni caso.";
  return (
    <div className={`flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] leading-relaxed text-amber-800 ${className}`} data-testid="ai-content-badge">
      <Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>{text}</span>
    </div>
  );
}
